import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import './mobile-tag-product-list-style.scss';

import SortListIcon from '@src/componentsNew/Icons/Icons/SortListIcon';
import FilterListIcon from '@src/componentsNew/Icons/Icons/FilterListIcon';
import SearchIcon from '@src/componentsNew/Icons/Icons/SearchIcon';
import WishlistIcon from '@src/componentsNew/Icons/Icons/WishlistIcon';
import CartQuantityIcon from '@src/componentsNew/Icons/CartQuantityIcon/CartQuantityIcon';

import Typography from '@src/componentsNew/Typography/Typography';
import MobileCustomHeader from '@src/componentsNew/Header/CustomHeader/MobileCustomHeader';
import MobileProductListSortingFilter from '@src/componentsNew/Modals/FilterModal/MobileProductListSortingFilter/MobileProductListSortingFilter';
import MobileProductListFilter from '@src/componentsNew/Modals/FilterModal/MobileProductListFilter/MobileProductListFilter';
import MobileBasicProductList from '@src/componentsNew/ProductList/Basic/MobileBasicProductList';

import { productsVariables } from '@components/ProductPage/ProductList/__generated__/products';
import { extractTagNameFromPath } from '@src/utils';
import { wishListUrl, searchUrl, cartUrl } from '@src/app/routes';

export interface IProps {
  initialVariables: productsVariables;
  variables: productsVariables;
  setVariables: (value: productsVariables) => void;
}

const MobileTagProductListPage = ({ initialVariables, variables, setVariables }: IProps) => {
  const history = useHistory();
  const location = useLocation();
  const queryString = new URLSearchParams(location.search);
  const tagName = queryString.get('name');

  const [numOfProducts, setNumOfProducts] = useState<number>(0);
  const [isSortingFilterModalOpen, setIsSortingFilterModalOpen] = useState(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const handleSortingFilterModalOpen = () => {
    setIsSortingFilterModalOpen(true);
  };

  const handleSortingFilterModalClose = () => {
    setIsSortingFilterModalOpen(false);
  };

  const handleFilterModalOpen = () => {
    setIsFilterModalOpen(true);
  };

  const handleFilterModalClose = () => {
    setIsFilterModalOpen(false);
  };

  return (
    <div id="mobile-tag-product-list-wrapper">
      <div className="fixed-area">
        <MobileCustomHeader
          type="left"
          isShowBackBtn={true}
          backBtnColor="#21242A7A"
          pageTitle={tagName || extractTagNameFromPath(location.pathname)}
          pageTitleColor="#212121"
          pageTitleVariant="h8"
          pageTitleComponent="h3"
          rightChild={
            <>
              <SearchIcon onClick={() => history.push(searchUrl)} />
              <WishlistIcon onClick={() => history.push(wishListUrl)} />
              <CartQuantityIcon isMobile={true} onClick={() => history.push(cartUrl)} />
            </>
          }
        />
      </div>

      <div className="sorting-filter-area">
        <div className="total-count-area">
          <Typography
            variant="subtitle2"
            component="span"
            style={{ color: '#11141D99' }}
          >{`${numOfProducts}`}</Typography>
          <Typography variant="body3" component="span" style={{ color: '#11141D99' }}>
            Products
          </Typography>
        </div>

        <div className="sorting-icon-wrapper">
          <SortListIcon onClick={handleSortingFilterModalOpen} />
          <FilterListIcon onClick={handleFilterModalOpen} />
        </div>
      </div>

      <MobileBasicProductList
        initialVariables={initialVariables}
        variables={variables}
        setNumOfProducts={setNumOfProducts}
      />

      {isSortingFilterModalOpen && (
        <MobileProductListSortingFilter
          open={isSortingFilterModalOpen}
          onClose={handleSortingFilterModalClose}
          variables={variables}
          setVariables={setVariables}
        />
      )}

      {isFilterModalOpen && (
        <MobileProductListFilter
          open={isFilterModalOpen}
          onClose={handleFilterModalClose}
          variables={variables}
          setVariables={setVariables}
        />
      )}
    </div>
  );
};

export default MobileTagProductListPage;
